/** Tranches de score de l'analyse par question (#159), bornes de l'API comprises. */
export const SCORE_BRACKETS = ['0-24', '25-49', '50-74', '75-100'] as const

/** La réponse attendue d'une question, ses variantes séparées ; vide si le module n'en déclare pas. */
export function expectedAnswer(correctResponses: string[]): string {
  return correctResponses.join(' | ')
}
